import { useForm, Controller } from "react-hook-form";
import moment from "moment";
import { useQuery } from "react-query";
import apiService from "services/api";
import { FormCheck, FormEntry, FormSelect } from "components";
import Select from "react-select";
import { useState } from "react";
import { useNotificationContext } from "contexts";
import { FormGroup, Label } from "reactstrap";

const initialFormData = {
	time: moment().format("hh:mm"),
	date: moment().format("YYYY-MM-DD"),
	staffId: undefined,
	centreId: undefined,
	remark: undefined,
	attendanceType: undefined,
};

const NewAttendancePage = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const { createNotification } = useNotificationContext();
	const { data: staffOptions, isLoading: isLoadingStaffOptions } = useQuery(
		["teacher"],
		() =>
			apiService.staff.get().then((staffs) =>
				staffs.map((staff) => ({
					value: staff.id,
					label: staff.fullName,
				}))
			),
		{ refetchOnWindowFocus: false }
	);
	const { data: centreOptions, isLoading: isLoadingCentres } = useQuery(["centre"], () =>
		apiService.student.centres().then((centres) =>
			centres.map((centre) => ({
				label: centre.shortName,
				value: centre.id,
				data: centre,
			}))
		)
	);

	const {
		register,
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm();

	const submitAttendance = (data) => {
		setIsSubmitting(true);
		const formData = { ...data };
		if (data.attendanceType === "arrival") formData.arrivalTime = data.time;
		else formData.leavingTime = data.time;

		apiService.attendance
			.create(formData)
			.then(() => {
				createNotification({ type: "success", message: "Successfully added attendance" });
				reset({ ...initialFormData, centreId: data.centreId, staffId: data.staffId });
			})
			.catch((error) => {
				createNotification({ type: "danger", message: error.message });
			})
			.finally(() => setIsSubmitting(false));
	};

	return (
		<div className="content">
			<h5 className="font-weight-bold text-center">New Attendance</h5>
			<form onSubmit={handleSubmit(submitAttendance)}>
				<FormEntry register={register} name="date" type="date" formLabel="Date" required error={errors.date} />
				<FormEntry register={register} name="time" type="time" formLabel="Time" step={60} required error={errors.time} />
				<div className="d-flex ml-1 mt-n3 align-items-center">
					<FormGroup className="mr-2">
						<input
							type="radio"
							{...register("attendanceType", { required: { value: true, message: "Select an attendance Type" } })}
							value="arrival"
						/>
						<small className="text-white ml-1">Arrival</small>
					</FormGroup>
					<FormGroup>
						<input
							type="radio"
							{...register("attendanceType", { required: { value: true, message: "Select an attendance Type" } })}
							value="leaving"
						/>
						<small className="text-white ml-1">Leaving</small>
					</FormGroup>
					{errors.attendanceType && <small className="text-danger ml-3">{errors.attendanceType.message}</small>}
				</div>
				<FormEntry
					register={register}
					name="remark"
					type="text"
					formLabel="Remark"
					placeholder="Reason of manually adding attendance"
					required
					error={errors.remark}
				/>
				<Controller
					control={control}
					rules={{ required: { value: true, message: "Select a centre" } }}
					name="centreId"
					render={({ field: { value, onChange } }) => (
						<Select
							className="react-select info mb-3"
							classNamePrefix="react-select"
							isClearable={true}
							value={centreOptions?.find((centre) => centre.value === value)}
							onChange={(val) => onChange(val.value)}
							placeholder="Select centre...."
							options={centreOptions || []}
							isDisabled={isLoadingCentres}
						/>
					)}
				/>
				<Controller
					control={control}
					rules={{ required: { value: true, message: "Select a staff" } }}
					name="staffId"
					render={({ field: { value, onChange } }) => (
						<Select
							className="react-select info mb-3"
							classNamePrefix="react-select"
							isClearable={true}
							value={staffOptions?.find((staff) => staff.value === value)}
							onChange={(val) => onChange(val.value)}
							placeholder="Select staff...."
							options={staffOptions || []}
							isDisabled={isLoadingStaffOptions}
						/>
					)}
				/>
				<div className="d-flex justify-content-end">
					<button className="btn btn-info mx-1" type="submit" disabled={isSubmitting}>
						Submit
					</button>
				</div>
			</form>
		</div>
	);
};

export default NewAttendancePage;
